export const LOGIN = "auth/login";
export const LOGOUT = "auth/logout";
export const RESET_PASSWORD = "auth/reset-password";
export const APP_USERNAME = 'auth/app-username';
